import React from 'react'
import { SingleSelectComboboxString } from '../../legacy-design-system/combobox'
import { CsGlobeIcon } from '../../legacy-design-system/icons/globe-icon'
import { Label } from '../../legacy-design-system/form-label'
import { css } from '@emotion/css'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { BetaLocales, SupportedLocales } from '../locale/locale'
import { ContrastFormattedMessage } from '../contrast-formatted-message'

export const localeSelectorTestId = 'locale-selector-test-id'

const globeIconCss = css`
  padding-left: 5px;
  color: ${theme.color.neutral70};
`

const languageCss = css`
  color: ${theme.color.neutral70};
`

export const localeDisplayValues: Record<string, string> = {
  en: 'English',
  es: 'Español (Beta)',
  ja: '日本語'
}

export interface LocaleSelectorProps {
  readonly hasBetaLanguage: boolean
  readonly locale: SupportedLocales | BetaLocales
  readonly disabled?: boolean
  readonly onChange?: (locale: SupportedLocales | BetaLocales) => void
}

export function LocaleSelector({
  disabled,
  locale,
  hasBetaLanguage,
  onChange
}: LocaleSelectorProps) {
  return disabled ? (
    <div>
      <LocaleSelectorLabel />
      <span className={languageCss}>
        {localeDisplayValues[locale.toLowerCase()]}
      </span>
    </div>
  ) : (
    <div>
      <SingleSelectComboboxString<string>
        disabled={disabled}
        renderLabel={LocaleSelectorLabel}
        items={[
          {
            items: getLocales({ hasBetaLanguage })
          }
        ]}
        value={locale.toLowerCase()}
        onChange={onChange}
        itemToString={(item) => localeDisplayValues[item]}
      />
    </div>
  )
}

function LocaleSelectorLabel() {
  return (
    <ContrastFormattedMessage id="title_language">
      {(languageTitle) => (
        <span
          className={css`
            display: flex;
          `}
        >
          <Label className={languageCss}>{languageTitle}</Label>
          <CsGlobeIcon width={20} height={20} className={globeIconCss} />
        </span>
      )}
    </ContrastFormattedMessage>
  )
}

function getLocales({
  hasBetaLanguage
}: {
  readonly hasBetaLanguage: boolean
}) {
  const languages: string[] = []
  Object.keys(SupportedLocales).forEach((item) => {
    languages.push(item)
  })
  if (hasBetaLanguage) {
    Object.keys(BetaLocales).forEach((item) => {
      languages.push(item)
    })
  }
  return languages
}
